import _Menu from './Menu';

import './style/index.js';

export type { MenuProps } from './Menu';
export type { HeadMenuProps } from './HeadMenu';
export type { SubMenuProps } from './SubMenu';
export type { MenuItemProps } from './MenuItem';
export type { MenuGroupProps } from './MenuGroup';
export * from './type';

export const Menu = _Menu;
export default Menu;
